module.exports = __webpack_public_path__ + "static/media/RoseSchneiderman.7055e5f9.jpg";